import { render, staticRenderFns } from "./HomeFoot.vue?vue&type=template&id=4b03bfc3&"
import script from "./HomeFoot.vue?vue&type=script&lang=js&"
export * from "./HomeFoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports